import React, { useRef } from "react";
import { useScroll } from "framer-motion";
import ChallengeLetter from "./ChallengeLetter";

const Challenge = () => {
  const descriptionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: descriptionRef,
    offset: ["start 50%", "end 20%"], // adjust scroll trigger
  });

  const descriptionText = [
    "ZOWO, a Saudi-based platform,",
    "invites you to a transport network",
    "where fairness and control meet.",
    "Convenience is at your fingertips.",
    "Request the right loading service",
    "for home moves or deliveries.",
    "Bulk cargo? We’ve got you covered.",
    "Negotiate prices openly, anytime.",
    "Deal directly with trusted drivers.",
    "All are verified, reliable, responsive.",
  ];
  const descriptionText1 = [
    "ZOWO, a Saudi-based platform,",
    "invites you to a transport network",
    "where fairness and control meet.",
    "Convenience is at your fingertips.",
    "Request the right loading service",
    "for home moves or deliveries.",
    "Bulk cargo? We’ve got you covered.",
    "Negotiate prices openly, anytime.",
    "Deal directly with trusted drivers.",
    "All are verified, reliable,",
    "responsive. Everything in your",
    "hands, with control and fairness.",
    "Start moving smarter with ZOWO.",
  ];

  let letterIndex = 0;

  return (
    <div className="challenge-container">
      <div className="challenge-heading">
        <div className="challenging">
          <span>Challenging</span>
          {window.innerWidth < 500 ? <></> : <div className="underline"></div>}
        </div>
        <div className="unjust">
          {window.innerWidth > 500 ? (
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="93"
                height="93"
                viewBox="0 0 93 93"
                fill="none"
              >
                <circle
                  cx="46.56"
                  cy="46.7999"
                  r="46.2"
                  fill={"var(--primary-color)"}
                />
              </svg>
            </div>
          ) : (
            <></>
          )}
          <span className="unjust">Unjust</span>{" "}
          <span className="pricing">Pricing</span>
        </div>
      </div>
      <div className="challenge-para-container" ref={descriptionRef}>
        <div className="challenge-text-container">
          {window.innerWidth > 480
            ? descriptionText.map((line, lineIdx) => (
                <div className="challenge-line" key={lineIdx}>
                  {[...line].map((letter, i) => {
                    const index = letterIndex++;
                    return (
                      <ChallengeLetter
                        key={`${lineIdx}-${i}`}
                        letter={letter}
                        index={index}
                        scrollYProgress={scrollYProgress}
                      />
                    );
                  })}
                </div>
              ))
            : descriptionText1.map((line, lineIdx) => (
                <div className="challenge-line" key={lineIdx}>
                  {[...line].map((letter, i) => {
                    const index = letterIndex++;
                    return (
                      <ChallengeLetter
                        key={`${lineIdx}-${i}`}
                        letter={letter}
                        index={index}
                        scrollYProgress={scrollYProgress}
                      />
                    );
                  })}
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default Challenge;
